<template>
    <v-select
        :options="options"
        :value="selected"
        :searchable="false"
        :clearable="false"
        @input="onChange"
    />
</template>
<script>
import vSelect from 'vue-select'
export default {
    name: 'AlgoliaSearchSelect',
    components: {
        'v-select': vSelect
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
        canRefine: {
            type: Boolean,
            required: true,
        },
        refine: {
            type: Function,
            required: true,
        },
        placeholder: {
            type: String,
            default: 'All',
        },
    },
    data() {
        return {
            allOption: { label: this.placeholder, value: '' },
        };
    },
    computed: {
        selected() {
            return this.items.filter((item) => item.isRefined)[0] || this.allOption;
        },

        options() {
            return [
                this.allOption,
                ...this.items,
            ];
        },
    },
    methods: {
        onChange({ value }) {
            this.refine(value);
        },
    },
}
</script>
<style lang="scss">
    @import "vue-select/src/scss/vue-select.scss";
    .v-select {
        @include media-query(lap-and-up) {
            margin-left: getSpacing(medium);
        }
    }

    .vs__dropdown-toggle {
        border: none!important;
        border-bottom: 2px solid $action-color!important;
        border-radius: 2px!important;
        padding: 0!important;
    }

    .vs__selected-options {
        padding: 0.5rem 0!important;
        font-size: 1rem;
        width: 100%;
        color: $base-font-color;
        font-family: $base-font-family;
    }

    .vs__selected {
        margin: 0;
        padding: 0;
        color: $base-font-color;
        line-height: 1.25;
        border: none;
    }

    .vs__search, .vs__search:focus {
        line-height: 1;
        border: 0;
        margin: 0;
        padding: 0;
    }

    .vs--single.vs--open .vs__selected {
        position: relative;
    }

    .vs__open-indicator {
        fill: $action-color;
    }
</style>
